import { render, staticRenderFns } from "./HeaderNextSkeleton.vue?vue&type=template&id=130f9e00&scoped=true&"
var script = {}
import style0 from "./HeaderNextSkeleton.vue?vue&type=style&index=0&id=130f9e00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130f9e00",
  null
  
)

export default component.exports